import React from 'react';
import Table from 'react-bootstrap/Table';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../lib/routing/frontend';

class HealthInsurerListTable extends React.Component {
  render() {
    const { healthInsurers = [] } = this.props;
    return (
      <div>
        <Table striped hover responsive className="health-insurer-list-table mb-0">
          <thead>
            <tr>
              <th>Name</th>
              <th className="text-center">Fee Assured Consultants</th>
              <th className="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            {healthInsurers.map((healthInsurer) => {
              return (
                <tr key={healthInsurer.id}>
                  <td>
                    <Link to={ROUTES.HEALTH_INSURERS.SINGLE.replace(':id', healthInsurer.id)} className="text-body">
                      {healthInsurer.name}
                    </Link>
                  </td>
                  <td className="text-center">{healthInsurer.feeAssuredConsultantCount ?? '-'}</td>
                  <td className="text-sm-left text-md-right">
                    <Link to={ROUTES.HEALTH_INSURERS.SINGLE.replace(':id', healthInsurer.id)} className="btn btn-sm btn-primary ml-2">
                      View
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

HealthInsurerListTable.propTypes = {
  healthInsurers: PropTypes.array.isRequired,
};

export default HealthInsurerListTable;
